import Player from '@/models/Player';
import PlayerTitle from '@/components/PlayerTitle/PlayerTitle.vue';

export default {
  name: 'PlayerName',
  components: {
    PlayerTitle,
  },
  props: {
    player: {
      type: Player,
      default: null,
    },
    clubId: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    title: {
      type: [String, Object],
      default: null,
    },
    withdrawn: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    displayName() {
      return this.player?.name || this.name || '—';
    },
  },
};
